import React from 'react';
import { Link } from 'react-router-dom';
import { useAdminData } from '../../contexts/AdminDataContext';
import { CONTACT_EMAIL, SERVICE_AREA, company } from '../../data/site';
import { telHref } from '../../utils/format';
import { FacebookLink } from './FacebookLink';
export function Footer() {
  const {
    settings
  } = useAdminData();
  return <footer className="border-t border-line bg-canvas-deep" data-id="element-783" data-mp="31fa7tciseoz1">
      <div className="mx-auto max-w-content px-5 py-12 lg:px-8" data-id="element-784" data-mp="3p4cmcbi4k1pb">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between" data-id="element-785" data-mp="3u3pijmuvyl4k">
          <div data-id="element-786" data-mp="3u5s6808kg264">
            <img src={company.logoWide} alt={settings.companyName} className="h-12 w-auto md:h-14" data-id="element-787" data-mp="3fet2b2ioe1sv" />
            <p className="mt-4 text-[15px] text-ink-soft" data-id="element-788" data-mp="3kdw8wreb0g2y">{settings.tagline}</p>
            <p className="mt-2 text-[15px] text-ink-soft" data-id="element-789" data-mp="3kbt6t8zvmwhv">
              Praktiske opgaver for dig i {SERVICE_AREA}
            </p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-790" data-mp="goj7e13fyyad">CVR: {settings.cvr}</p>
            <FacebookLink className="mt-5 text-sm" data-id="element-791" data-mp="gqm75cuec5sa" />
          </div>

          <div className="flex flex-col gap-2 text-[15px] md:items-end" data-id="element-792" data-mp="3jg47488uc4df">
            {settings.phone && <a href={telHref(settings.phone)} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-793" data-mp="3eichxlzkywcx">
                {settings.phone}
              </a>}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-794" data-mp="60g565di6vip">
              {CONTACT_EMAIL}
            </a>
            <div className="mt-3 flex gap-5 text-sm text-ink-muted" data-id="element-795" data-mp="f1nwg3hlqw3a">
              <a href="#kontakt" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-796" data-mp="azsx34j8ess5">
                Kontakt
              </a>
              <a href="#privatliv" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-797" data-mp="2gtiwfluhxc5o">
                Privatlivspolitik
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-line pt-6 text-sm text-ink-muted" data-id="element-798" data-mp="fs2vxxox0peh">
          <p data-id="element-799" data-mp="krfs591of8tq">
            © {new Date().getFullYear()} {settings.companyName}
          </p>
          <Link to="/admin/login" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-800" data-mp="pqsgjy874nyf">
            Admin
          </Link>
        </div>
      </div>
    </footer>;
}